import SetLayout from './SetLayout';

export default SetLayout;
